import { KozoomVideo } from "constants/types";

export const isYoutubeUrl = (url: string) => {
  var p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  const match = url.match(p);
  if (match) {
    return match[1];
  }
  return false;
};

export const isFacebookUrl = (url: string) => {
  if (/^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i.test(url)) return true;
  return false;
};

export const isTwitchUrl = (url: string) => {
  if (/^(https?:\/\/)?((w{3}\.)?)twitch.tv\/.*/i.test(url)) return true;
  return false;
};

export function captureVideoFrame(video: HTMLVideoElement | null, format: string, quality: number) {
  if (typeof video === "string") {
    video = document.getElementById(video) as HTMLVideoElement;
  }

  format = format || "jpeg";
  quality = quality || 0.92;

  if (!video || (format !== "png" && format !== "jpeg")) {
    return false;
  }

  const canvas = document.createElement("CANVAS") as HTMLCanvasElement;

  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;

  const context = canvas.getContext("2d");
  if (context) {
    context.drawImage(video, 0, 0);
  }

  var dataUri = canvas.toDataURL("image/" + format, quality);
  var data = dataUri.split(",")[1];
  var mimeType = dataUri.split(";")[0].slice(5);

  var bytes = window.atob(data);
  var buf = new ArrayBuffer(bytes.length);
  var arr = new Uint8Array(buf);

  for (var i = 0; i < bytes.length; i++) {
    arr[i] = bytes.charCodeAt(i);
  }

  var blob = new Blob([arr], { type: mimeType });
  return { blob: blob, dataUri: dataUri, format: format };
}

export function getVideoThumbnail(video: KozoomVideo) {
  if (video === null) {
    return "https://placehold.co/600x400/EEE/31343C";
  }
  if (video.thumbnail?.startsWith("http")) {
    return video.thumbnail;
  }
  if (video.url?.includes("youtube.com") || video.url?.includes("youtu.be")) {
    return getYoutubeThumbnail(video.url);
  }
  if (video.thumbnail) {
    return `https://kozoom.b-cdn.net/uploads/events/${video.eventId}/videos/${video.thumbnail}`;
  }
  return '';
}

export const getYoutubeThumbnail = (url: string) => {
  if (url === null) {
    return "";
  }
  const patterns = [
    /youtu\.be\/([^?&#]+)/,                           // youtu.be/<id>
    /youtube\.com\/watch\?v=([^&#]+)/,                // youtube.com/watch?v=<id>
    /youtube\.com\/embed\/([^&#]+)/,                  // youtube.com/embed/<id>
    /youtube\.com\/v\/([^&#]+)/,                      // youtube.com/v/<id>
    /youtube\.com\/shorts\/([^&#]+)/                  // youtube.com/shorts/<id>
  ];
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      const videoId = match[1];
      return `https://img.youtube.com/vi/${videoId}/sddefault.jpg`
    }
  }
  return "https://img.youtube.com/vi/any/sddefault.jpg";
};